/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reopen_Confirm_Vekn_WarnInputs */



/**
* | output |
* | --- |
* | "Results were already sent to vekn.net. Changes made after reopening won't reach it; only a VEKN admin can fix them there." |
*
* @param {Reopen_Confirm_Vekn_WarnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const reopen_confirm_vekn_warn = /** @type {((inputs?: Reopen_Confirm_Vekn_WarnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reopen_Confirm_Vekn_WarnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les résultats ont déjà été envoyés à vekn.net. Les modifications après réouverture n'y arriveront pas ; seul un admin VEKN peut les corriger là-bas.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los resultados ya se enviaron a vekn.net. Los cambios tras reabrir no llegarán allí; solo un admin de la VEKN puede corregirlos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os resultados já foram enviados à vekn.net. Mudanças após reabrir não chegarão lá; só um admin da VEKN pode corrigi-las.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I risultati sono già stati inviati a vekn.net. Le modifiche dopo la riapertura non ci arriveranno; solo un admin VEKN può correggerle lì.")
	return /** @type {LocalizedString} */ ("Results were already sent to vekn.net. Changes made after reopening won't reach it; only a VEKN admin can fix them there.")
});